import React, { useState } from "react";
import ReReSubject from "./ReReSubject";
import { StandardButton } from "../../common/GlobalElements/StandardButton";
import { tokens } from "../../../public/tokens";

function RedoSubject(props) {
  const {
    formik,
    setParentSubjectRedoLength,
    parentSubjectRedoLength,
    reRegSubject,
    setDelivery_methode
  } = props;

  const [fields, setFields] = useState([{ subject: "" }]);

  function handleAdd() {
    const values = [...fields];
    values.push({ subject: "" });
    setFields(values);
    setParentSubjectRedoLength(values);
  }

  function handleRemove(i) {
    const values = [...fields];
    if (values.length > 1) {
      values.splice(i, 1);
      setFields(values);
      setParentSubjectRedoLength(values);
    }else{
      // If only one field is left, reset it to empty
      values[0].subject = '';
      setFields(values);
      setParentSubjectRedoLength(values);
      props.handleDisableField != undefined && props.handleDisableField(values, "re-do");
    }
  }

  function handleSubjectChange(i, event) {
   
    const values = [...fields];
    values[i].subject = event.target.value;
    setFields(values);
    setParentSubjectRedoLength(values);
    if (values[0].subject!='') {
      setDelivery_methode != undefined && setDelivery_methode('');
    }else {
      setDelivery_methode != undefined && setDelivery_methode('online');
    }
    props.handleDisableField != undefined && props.handleDisableField(values, "re-do");
  }


  return (
    <>
      {formik.values.subjectRedo_.map((item, idx) => (
          <div className="row" key={item}>
            <div className="col-sm-6 d-flex gap-2">
              <select
                className="form-control"
                name={`subjectRedo_[${idx}].subject`}
                onChange={(e) => handleSubjectChange(idx, e)}
                onBlur={formik.handleBlur}
                key={idx}
                value={formik.values.subjectRedo_[idx].subject}
                disabled={props.disable}
              >
                <option value="">---</option>
                <ReReSubject reRegSubject={reRegSubject} selectedSubjects={fields} currentIndex={idx}  />
              </select>

              {formik.touched.subjectRedo_ &&
              formik.errors.subjectRedo_ &&
              formik.touched.subjectRedo_[idx] &&
              formik.errors.subjectRedo_[idx] &&
              formik.touched.subjectRedo_[idx].subject &&
              formik.errors.subjectRedo_[idx].subject ? (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {formik.errors.subjectRedo_[idx].subject}
                </div>
              ) : null}
              </div>
            { !props.disable &&
            <div className="col pl-0">
              <StandardButton variant="danger" isRounded onClick={() => handleRemove(idx)}>
                <i className="fal fa-trash-alt"></i>
              </StandardButton>
            </div>}
            
          </div>
      ))}
      {
        (fields.length < reRegSubject.length && !props.disable) &&
      <React.Fragment>
        <div className="form-group m-0">
          <StandardButton textOnly fontWeight={tokens.typography.fontWeights.regular} variant="theme" onClick={() => handleAdd()}>
            <i className="fal fa-plus"></i> Add additional line item
          </StandardButton>
        </div>
      </React.Fragment>
      }
    </>
  );
}

export default RedoSubject;
